export default __webpack_public_path__ + "static/tiva-c8857578c63821ae559ace411dac76ad.png";